import { CMS_REQUEST_LOGIN_START, CMS_REQUEST_LOGIN_SUCCESS, CMS_REQUEST_LOGIN_FAIL } from '../../actions/cms/authen_cms'
import { CMS_REQUEST_LOGOUT_START, CMS_REQUEST_LOGOUT_SUCCESS, CMS_REQUEST_LOGOUT_FAIL } from '../../actions/cms/authen_cms'
import { CMS_REQUEST_PING_START, CMS_REQUEST_PING_SUCCESS, CMS_REQUEST_PING_FAIL } from '../../actions/cms/authen_cms'

export const initialState = {
    error: null,
    data: null,
    isLoading: false,
    pageList: [],
    isConnected: false,
    isConnectPage: false,
    pageDetail: null,
}

export const reducer = (state = initialState, action) => {
    const { type, data, payload, error } = action

    switch (type) {
        case CMS_REQUEST_LOGIN_START: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.req, isLoading: true, type } }
        }
        case CMS_REQUEST_LOGIN_SUCCESS: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type }, error: null }
        }
        case CMS_REQUEST_LOGIN_FAIL: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type }, error: payload.res }
        }

        case CMS_REQUEST_LOGOUT_START: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.req, isLoading: true, type } }
        }
        case CMS_REQUEST_LOGOUT_SUCCESS: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type } }
        }
        case CMS_REQUEST_LOGOUT_FAIL: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type } }
        }

        case CMS_REQUEST_PING_START: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.req, isLoading: true, type } }
        }
        case CMS_REQUEST_PING_SUCCESS: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type } }
        }
        case CMS_REQUEST_PING_FAIL: {
            /*console.log(type, { state, action, payload })*/
            return { ...state, issue: { ...payload.res, isLoading: false, type } }
        }

        default: {
            return { ...state }
        }
    }
}

export default reducer
